export const APP_PUBLIC_NAME = {'es': 'Dashboard', 'en': 'Dashboard'};